import { useState } from 'react';
import { TrashIcon } from './icons';

interface DeleteButtonProps {
  onConfirm: () => void;
  title?: string;
}

export function DeleteButton({ onConfirm, title = 'Delete' }: DeleteButtonProps) {
  const [confirming, setConfirming] = useState(false);

  if (confirming) {
    return (
      <span className="delete-confirm">
        <span className="delete-confirm-label">Delete?</span>
        <button type="button" className="btn-xs btn-danger" onClick={() => { setConfirming(false); onConfirm(); }}>
          Yes
        </button>
        <button type="button" className="btn-xs" onClick={() => setConfirming(false)}>
          No
        </button>
      </span>
    );
  }

  return (
    <button type="button" className="icon-btn icon-btn-danger" title={title} onClick={() => setConfirming(true)}>
      <TrashIcon />
    </button>
  );
}
